import { PlanRoutingModule } from "./plan-routing.module";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CustomTranslateLoader } from "./services/custom-translate-loader";
import { TenantService } from "./tenant.service";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NgModule, provideZoneChangeDetection } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { PageModule } from "./pages/page.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { reducers } from "./store/reducers/index";
import {BrowserModule} from '@angular/platform-browser';
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { AuthenticationGuard } from "src/app/authentication.guard";
import { environment } from "../environments/environment";
import { EffectsModule } from "@ngrx/effects";
import { WfmTokenInterceptor } from "./interceptors/wfm-token.interceptor";
import { PlanEffects } from "./store/effects/plan";
import { AppEffects } from "./store/effects/app";
import { ForecastEffects } from "./store/effects/forecasts";
import {AuthenticationService} from "./authentication.service";
import {DatePipe} from "@angular/common";
import { NgxEchartsModule } from "ngx-echarts";
import * as echarts from 'echarts';
import {CanDeactivateGuard} from "./helpers/can-deactivate-guard.service";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {ImportedForecastsRoutingModule} from "./imported-forecasts-routing.module"
import { ToastModule } from "primeng/toast";
import {ComponentModule} from "./components/component.module";
import { TooltipModule } from "primeng/tooltip";
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import {HistoricalDataRoutingModule} from './history-routing.module';
import {HistoricalDataEffects} from './store/effects/historical-data';
import {ApiCredentialEffects } from './store/effects/api-credential';
import {MFEBridgeService} from './services/mfe-bridge.service';
import {CxoneEffects} from './store/effects/cxone';
import {mockBackendProvider} from './helpers/mock-backend';


@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [PageModule,
        FormsModule,
        BrowserModule,
        ReactiveFormsModule,
        PlanRoutingModule,
        ImportedForecastsRoutingModule,
        HistoricalDataRoutingModule,
        AppRoutingModule,
        NgSelectModule,
        NgxEchartsModule.forRoot({ echarts }),
        NgbModule,
        TooltipModule,
        RouterModule,
        BrowserAnimationsModule,
        ToastModule,
        /**
         * StoreModule.forRoot is imported once in the root module, accepting a reducer
         * function or object map of reducer functions. If passed an object of
         * reducers, combineReducers will be run creating your application
         * meta-reducer. This returns all providers for an @ngrx/store
         * based application.
         */
        StoreModule.forRoot(reducers),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            name: "ESP",
            logOnly: environment.production
        }),
        EffectsModule.forRoot([
            PlanEffects,
            AppEffects,
            ForecastEffects,
            HistoricalDataEffects,
            ApiCredentialEffects,
            CxoneEffects
        ]),
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient, TenantService]
            }
        }),
        ComponentModule], providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        providePrimeNG({
            theme: {
                preset: Lara,
                options: { prefix: 'p', darkModeSelector: 'none' }
            }
        }),
        mockBackendProvider,
        AuthenticationGuard,
        AuthenticationService,
        DatePipe,
        CanDeactivateGuard,
        MFEBridgeService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: WfmTokenInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient, tenantService: TenantService) {
  return new CustomTranslateLoader(http, 'assets/i18n/', '.json', tenantService.isCXOne);
}
